import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { notificationsMessages } from './translations';

/**
 * pt-BR texts of Notificações (Story 2.3). The page itself stays the
 * plugin's; its title ("Notificações") is set in app-config.yaml. The app's
 * translations input only accepts extensions of the app plugin itself.
 */
export const notificationsTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [notificationsMessages],
});
